import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";

/**
 * This service is meant to be be consumed by a component that manages changing of the dynamic UI components where the
 * layout depends on the dynamic variables.
 */
@Injectable({
	providedIn: "root",
})
export class DynamicUiService {
	private height$ = new BehaviorSubject<number>(0);

	headerHeight$(): Observable<number> {
		return this.height$;
	}

	setHeaderHeight(height: number) {
		this.height$.next(height);
	}
}
